import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";

/* ✅ DATE ONLY — NO TIME */
const formatDateOnly = (dt) => {
  if (!dt) return "-";
  const d = new Date(dt);
  if (isNaN(d.getTime())) return "-";

  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export default function AdminDeliveryCashSettlement() {
  const navigate = useNavigate();

  const [boys, setBoys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [settlingId, setSettlingId] = useState(null);

  const [cashSummary, setCashSummary] = useState({});
  const [cashNotes, setCashNotes] = useState({});

  /* ---------------- LOAD ALL DATA ---------------- */
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await axios.get("/admin/delivery-earning-preview/");
      const boysData = res.data.delivery_boys || [];
      setBoys(boysData);

      // 🔥 Load summary + notes automatically
      boysData.forEach((boy) => {
        loadDailyCashSummary(boy.delivery_boy_id);
        loadCashNotes(boy.delivery_boy_id);
      });
    } catch {
      alert("Failed to load delivery cash data");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- LOAD SUMMARY ---------------- */
  const loadDailyCashSummary = async (boyId) => {
    try {
      const res = await axios.get(
        `/admin/daily-cash-summary/?delivery_boy_id=${boyId}`
      );

      setCashSummary((prev) => ({
        ...prev,
        [boyId]: {
          totalCod: res.data.total_cod || 0,
          totalSettled: res.data.total_settled || 0,
        },
      }));
    } catch {
      setCashSummary((prev) => ({
        ...prev,
        [boyId]: { totalCod: 0, totalSettled: 0 },
      }));
    }
  };

  /* ---------------- LOAD NOTES (READ ONLY) ---------------- */
  const loadCashNotes = async (boyId) => {
    try {
      const res = await axios.get(
        `/admin/get-cash-notes/?delivery_boy_id=${boyId}`
      );

      setCashNotes((prev) => ({
        ...prev,
        [boyId]: res.data.notes || [],
      }));
    } catch {
      setCashNotes((prev) => ({
        ...prev,
        [boyId]: [],
      }));
    }
  };

  /* ---------------- SETTLE CASH ---------------- */
  const handleSettle = async (boy) => {
    if (!boy.amount || Number(boy.amount) <= 0) {
      alert("Enter valid amount");
      return;
    }

    try {
      setSettlingId(boy.delivery_boy_id);

      await axios.post("/admin/settle-daily-cash/", {
        delivery_boy_id: boy.delivery_boy_id,
        amount: boy.amount,
      });

      boy.amount = "";

      await loadDailyCashSummary(boy.delivery_boy_id);
      await loadCashNotes(boy.delivery_boy_id);

      alert("Cash settled successfully");
    } catch {
      alert("Settlement failed");
    } finally {
      setSettlingId(null);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>💵 Daily Delivery Cash Settlement</h2>
     

<button
  onClick={() => navigate("/admin/delivery-notes")}
  style={{
    marginBottom: 16,
    padding: "8px 14px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
  }}
>
  📝 Manage Delivery Notes
</button>

      {boys.map((boy) => (
        <div
          key={boy.delivery_boy_id}
          style={{
            border: "1px solid #ddd",
            borderRadius: 8,
            padding: 16,
            marginBottom: 16,
            background: "#fafafa",
          }}
        >
          <h4>
            {boy.name} ({boy.phone})
          </h4>

          <p><b>Pending Cash:</b> ₹{boy.pending_cash}</p>
          <p>Total COD: ₹{cashSummary[boy.delivery_boy_id]?.totalCod || 0}</p>
          <p>Total Settled: ₹{cashSummary[boy.delivery_boy_id]?.totalSettled || 0}</p>

          {/* ✅ READ ONLY NOTES */}
          {cashNotes[boy.delivery_boy_id]?.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <b>Admin Notes</b>

              {cashNotes[boy.delivery_boy_id].map((n, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 12px",
                    marginTop: 6,
                    background: "#fff",
                    borderRadius: 6,
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <div>{n.note}</div>
                  <div style={{ fontSize: 12, color: "#6b7280" }}>
                    {formatDateOnly(n.date)}
                  </div>
                </div>
              ))}
            </div>
          )}

          <input
            type="number"
            placeholder="Cash received today"
            value={boy.amount || ""}
            onChange={(e) => {
              boy.amount = e.target.value;
              setBoys([...boys]);
            }}
            style={{ width: "100%", padding: 8, marginTop: 10 }}
          />

          <button
            disabled={settlingId === boy.delivery_boy_id}
            onClick={() => handleSettle(boy)}
            style={{
              background: "#28a745",
              color: "#fff",
              padding: "8px 16px",
              border: "none",
              borderRadius: 4,
              marginTop: 10,
            }}
          >
            {settlingId === boy.delivery_boy_id ? "Settling..." : "Settle Cash"}
          </button>
        </div>
      ))}
    </div>
  );
}
